import { SettingsService } from './../shared/providers/settings.service';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { FOOTER_MODE } from '../models/menu';
import { CARDS_MODE, CARD_CONTROL_BTN, CARD_PURCHASE_STATUS, CARD_TYPE, ICard, ICardAction, ICardFeedModificator, INavpanelAction, NAVPANEL_ACTION_TYPE, SWITCH_PANEL_ITEM } from '../models/card';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogData, ConfirmationDialogComponent } from '../shared/components/dialog/confirmation-dialog.component';
import { POPUP_TEXT } from 'src/app/shared/text/popup-texts';
import { FirebaseAuthService } from '../shared/providers/firebase-auth.service';
import { CardsService } from '../shared/providers/cards.service';
import { environment } from 'src/environments/environment';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'firebase/auth';
import { WebrenderlimitComponent } from './webrenderlimit/webrenderlimit.component';
import { goRenderHome } from './render/render-home';
import { renderOnly } from '../shared/feature-flags';
import { ICardCollection } from '../models/collection';
import { UploadFileService } from 'src/app/shared/providers/upload-file.service';

@Injectable({
  providedIn: 'root'
})
export class WebNavService {
  @Output() public webNavSwitchPanelChange: EventEmitter<SWITCH_PANEL_ITEM> = new EventEmitter<SWITCH_PANEL_ITEM>();
  @Output() public webNavForceShowDragZoneActivatedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public webAuthPopupClosed: EventEmitter<boolean> = new EventEmitter<boolean>();


  public get notAuthorizedUserBefore(): boolean {
    return this.settingsService.getOriginalUidFromLocalstorage() === null;
  }

  public isUserAuthenticated: boolean = false;
  public footerMode: FOOTER_MODE = FOOTER_MODE.LIBRARY;
  public currentWebSwitchPanelMode: SWITCH_PANEL_ITEM = SWITCH_PANEL_ITEM.ALL;
  public hideLibrarySectionSwitch: boolean = false;
  public readonly unauthLibraryMainCtaLabel: string = '$65/year';
  public readonly unauthLibraryRefundNote: string = 'We will cancel and refund your membership at any time if you are dissatisfied.';

  public addWebPanelItems: INavpanelAction[] = [
    { actionName: 'New Collection', actionType: NAVPANEL_ACTION_TYPE.NEW_COLLECTION },
    { actionName: 'Upload Model', actionType: NAVPANEL_ACTION_TYPE.UPLOAD_MODEL }
  ]

  public editCollectionMoreWebPanelItems: INavpanelAction[] = [
    { actionName: 'Edit Collection', actionType: NAVPANEL_ACTION_TYPE.EDIT_COLLECTION },
    { actionName: 'Delete Collection', actionType: NAVPANEL_ACTION_TYPE.DELETE_COLLECTION }
  ]

  public editCollectionAddWebPanelItems: INavpanelAction[] = [
    { actionName: 'Add from Library', actionType: NAVPANEL_ACTION_TYPE.ADD_FROM_LIBRARY },
    { actionName: 'Upload Model', actionType: NAVPANEL_ACTION_TYPE.UPLOAD_MODEL }
  ]

  public proftileDevAccountWebPanelItems: INavpanelAction[] = [
    { actionName: 'Settings', actionType: NAVPANEL_ACTION_TYPE.SETTINGS },
    { actionName: 'Sign Out', actionType: NAVPANEL_ACTION_TYPE.SIGN_OUT },
  ]

  public profileProdAccountWebPanelItems: INavpanelAction[] = [
    { actionName: 'Sign Out', actionType: NAVPANEL_ACTION_TYPE.SIGN_OUT },
  ]

  public collectionDetailsWebPanelItemsLiked: INavpanelAction[] = [
    {actionName: 'Remove Collection', actionType: NAVPANEL_ACTION_TYPE.LIKE_COLLECTION },
  ]

  public collectionDetailsWebPanelItemsUnliked: INavpanelAction[] = [
    {actionName: 'Add Collection', actionType: NAVPANEL_ACTION_TYPE.LIKE_COLLECTION },
  ]

  public filteredAllModels: ICard[];
  public firebaseUserSubscription: Subscription;
  public notLoggedSubscription: Subscription;
  public cardChangeSub: Subscription;


  constructor(
    public settingsService: SettingsService,
    public userDataService: UserDataService,
    public uploadService: UploadFileService,
    public cardService: CardsService,
    public firebaseAuth: FirebaseAuthService,
    public utilityService: UtilityFunctionsService,
    public dialog: MatDialog,
    public router: Router
  ) {

    // Add AI Collection Description button only in non-production environment
    // This feature is experimental and should not be visible to production users
    if (!environment.production) {
      this.editCollectionMoreWebPanelItems.unshift({ actionName: 'Get Collection AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_COLLECTION_AI_DESCRIPTION });
    }

    this.isUserAuthenticated = !!this.firebaseAuth.currentUser;
    this.notLoggedSubscription = this.firebaseAuth.notLoggedUserSubscription.subscribe(() => {
      this.isUserAuthenticated = false;

    })

    this.firebaseUserSubscription = this.firebaseAuth.firebaseUser.subscribe((user: User) => {
      this.isUserAuthenticated = false;
      if (user) {
        this.isUserAuthenticated = true;
      }
    });

    this.cardChangeSub = this.cardService.currentCardSubject.subscribe((card: ICard) => {
      // TODO: Check if modelId is in URL and change it to the card parameter without page reload
      if(card.cardType === CARD_TYPE.MODEL) {
        this.updateModelIdInUrl(card.id);
      }

    });


  }

  public isNoDataShown(): boolean {
    return this.userDataService.userReviewPublishRejectModels?.length === 0 && this.userDataService.allUserDraftCollections?.length === 0 && this.uploadService.uploadModels.length === 0 &&
           this.userDataService.savedCards.length === 0 && this.userDataService.savedCollections.length === 0 && this.userDataService.uploadedCards.length === 0 &&
           this.userDataService.isRecievedModelsRespFromBackend && this.userDataService.isRecievedDraftCollectionsRespFromBackend;
  }

  public shouldShowClassicLanding(): boolean {
    return (!this.isUserAuthenticated && !this.settingsService.getOriginalUidFromLocalstorage())
  }

  public getLibraryMainButtonLabel(): string {
    return this.shouldShowClassicLanding() ? this.unauthLibraryMainCtaLabel : 'Add';
  }

  public shouldHideLibrarySearchAndDivider(): boolean {
    return this.getLibraryMainButtonLabel() === this.unauthLibraryMainCtaLabel;
  }

  public onWebNavSwitchPanelClick(button: SWITCH_PANEL_ITEM): void {
    this.currentWebSwitchPanelMode = button;
    this.webNavSwitchPanelChange.emit(button);
  }


  public getOptionsBtnItems(card: ICard, feedMode: CARDS_MODE, feedModificator?: ICardFeedModificator ): INavpanelAction[] {
    let action: ICardAction
    switch (true) {
      case card.purchaseStatus === undefined || card.purchaseStatus === CARD_PURCHASE_STATUS.DEFAULT_3DWAY && this.userDataService.isCardExitsInSaved(card):
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_LIKED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.DRAFT_LIKED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_LIKED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.DRAFT_NOT_LIKED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTIONS_FOR_UNLIKED }
        break;
      case feedMode === CARDS_MODE.EDIT_CARD:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_EDIT_CARD }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.DEFAULT_3DWAY:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTIONS_DEFAULT }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_UPLOADED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTIONS_FOR_PURCHASED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.IN_REVIEW:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_IN_REVIEW }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_MORE_FOR_REJECTED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.PUBLISHED:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_PUBLISHED }
        break;
      case card.purchaseStatus === CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT:
        action = { card, controlAction: CARD_CONTROL_BTN.CONTROL_ACTION_FOR_REVIEW_PUBLISH_REJECT }
        break;

      default:
        break;
      }
      const navpanelItems = this.getNavpanelItemsBasedOnCardAction(action, feedModificator);
      const navpanelItemsWithStoreAdminActions = this.appendStoreAdminModerationActions(navpanelItems, card, feedModificator);
      return this.filterCancelPublishingForInReviewAdminMode(navpanelItemsWithStoreAdminActions, feedModificator);
    }

  private appendStoreAdminModerationActions(
    navpanelItems: INavpanelAction[],
    card: ICard,
    feedModificator?: ICardFeedModificator
  ): INavpanelAction[] {
    if (!feedModificator?.isStoreFeed) return navpanelItems;
    if (card?.cardType !== CARD_TYPE.MODEL) return navpanelItems;
    if (this.firebaseAuth.currentUser?.isAdmin !== true) return navpanelItems;

    const isCancelPublishingAlreadyAdded = navpanelItems.some(
      item => item.actionType === NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING
    );
    if (isCancelPublishingAlreadyAdded) return navpanelItems;

    return [
      ...navpanelItems,
      { actionName: 'Cancel Publishing', actionType: NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING }
    ];
  }

  private filterCancelPublishingForInReviewAdminMode(
    navpanelItems: INavpanelAction[],
    feedModificator?: ICardFeedModificator
  ): INavpanelAction[] {
    if (!feedModificator?.isInReviewAdminMode) return navpanelItems;

    return navpanelItems.filter(
      item => item.actionType !== NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING
    );
  }


  public getNavpanelItemsBasedOnCardAction(action: ICardAction, feedModificator?: ICardFeedModificator): INavpanelAction[] {
    let navpanelItems: INavpanelAction[] = [];

    switch (action.controlAction) {
      case CARD_CONTROL_BTN.CONTROL_ACTIONS_DEFAULT:
        if(action.card.cardType === CARD_TYPE.COLLECTION) {
          const isExistInSaved = this.userDataService.isCollectionExitsInSaved(action.card.id);
          const actionText = isExistInSaved ? 'Remove from Library' : 'Add to Library';
          const actionItself = isExistInSaved ? NAVPANEL_ACTION_TYPE.UNLIKE_COLLECTION : NAVPANEL_ACTION_TYPE.LIKE_COLLECTION;
          navpanelItems = [
            {actionName: actionText, actionType: actionItself },
          ]
        } else {
          const isExistInSaved = this.userDataService.isCardExitsInSaved(action.card);
          const actionText = isExistInSaved ? 'Remove from Library' : 'Add to Library';
          navpanelItems = [
            {actionName: actionText, actionType: NAVPANEL_ACTION_TYPE.UNLIKE_CARD  },
          ]
          // Add AI Description button only in non-production environment
          if (!environment.production) {
            navpanelItems.push({actionName: 'Get AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION });
          }
        }

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_REVIEW_PUBLISH_REJECT:
        // default
        navpanelItems = [
          {actionName: 'Rename Model', actionType: NAVPANEL_ACTION_TYPE.RENAME_CARD },
          {actionName: 'Delete Model', actionType: NAVPANEL_ACTION_TYPE.DELETE_CARD }
        ]
        // modificator for edit collection:
        if(feedModificator?.isFeedForEditCollection) {
          navpanelItems = [
            {actionName: 'Rename Model', actionType: NAVPANEL_ACTION_TYPE.RENAME_CARD },
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION }
          ]
        }
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_UPLOADED:
        // default
        navpanelItems = [
          {actionName: 'Rename Model', actionType: NAVPANEL_ACTION_TYPE.RENAME_CARD },
          {actionName: 'Delete Model', actionType: NAVPANEL_ACTION_TYPE.DELETE_CARD }
        ]
        // Add AI Description button only in non-production environment
        if (!environment.production) {
          navpanelItems.unshift({ actionName: 'Get AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION });
        }
        // modificator for edit collection:
        if(feedModificator?.isFeedForEditCollection) {
          navpanelItems = [
            {actionName: 'Rename Model', actionType: NAVPANEL_ACTION_TYPE.RENAME_CARD },
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION }
          ]
          // Add AI Description button only in non-production environment
          if (!environment.production) {
            navpanelItems.unshift({ actionName: 'Get AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION });
          }
        }
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_EDIT_CARD:
        navpanelItems = [
        ]

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_LIKED:
        // default
        navpanelItems = [
          {actionName: 'Remove from Library', actionType: NAVPANEL_ACTION_TYPE.UNLIKE_CARD },
        ]
        // Add AI Description button only in non-production environment
        if (!environment.production) {
          navpanelItems.unshift({ actionName: 'Get AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION });
        }
        // modificator for edit collection:
        if(feedModificator?.isFeedForEditCollection) {
          // In edit-collection, saved cards should keep their liked state in Library.
          // The action here only removes the card from the current collection.
          navpanelItems = [
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION },
          ]
          // Add AI Description button only in non-production environment
          if (!environment.production) {
            navpanelItems.unshift({ actionName: 'Get AI Description', actionType: NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION });
          }
        }
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTIONS_FOR_PURCHASED:
        navpanelItems = [
        ]

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_IN_REVIEW:
        navpanelItems = [
          {actionName: 'Cancel Publishing', actionType: NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING },
        ]
        if (feedModificator?.isFeedForEditCollection) {
          navpanelItems = [
            ...navpanelItems,
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION }
          ]
        }

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_REJECTED:
        navpanelItems = [
        ]
        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_MORE_FOR_REJECTED:
        navpanelItems = [
          {actionName: 'Delete Model', actionType: NAVPANEL_ACTION_TYPE.DELETE_CARD },
        ]
        if (feedModificator?.isFeedForEditCollection) {
          navpanelItems = [
            ...navpanelItems,
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION }
          ]
        }

        break;
      case CARD_CONTROL_BTN.CONTROL_ACTION_FOR_PUBLISHED:
        navpanelItems = [
          {actionName: 'Cancel Publishing', actionType: NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING },
        ]
        if (feedModificator?.isFeedForEditCollection) {
          navpanelItems = [
            ...navpanelItems,
            {actionName: 'Remove from Collection', actionType: NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION }
          ]
        }

        break;
      default:
        navpanelItems = [
        ]
        break;
    }
    return navpanelItems;
  }

  public getCardControlActionBasedOnNavpanelItem(action: INavpanelAction, card: ICard): ICardAction {
    let cardAction: ICardAction;
    switch (action.actionType) {
      case NAVPANEL_ACTION_TYPE.UNLIKE_CARD:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.UNLIKE_DRAFT_CARD }
        break;
      case NAVPANEL_ACTION_TYPE.LIKE_COLLECTION:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.LIKE_DRAFT_CARD }
        break;
      case NAVPANEL_ACTION_TYPE.UNLIKE_COLLECTION:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.UNLIKE_DRAFT_CARD }
        break;
      case NAVPANEL_ACTION_TYPE.CANCEL_PUBLISHING:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.CANCEL_PUBLISH }
        break;
      case NAVPANEL_ACTION_TYPE.DELETE_CARD:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.DELETE_MODEL }
        break;
      case NAVPANEL_ACTION_TYPE.RENAME_CARD:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.RENAME_CARD }
        break;
      case NAVPANEL_ACTION_TYPE.REMOVE_CARD_FROM_COLLECTION:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.REMOVE_CARD_FROM_COLLECTION }
        break;
      case NAVPANEL_ACTION_TYPE.GET_AI_DESCRIPTION:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.GET_AI_DESCRIPTION }
        break;
      case NAVPANEL_ACTION_TYPE.GET_COLLECTION_AI_DESCRIPTION:
        cardAction = { card, controlAction: CARD_CONTROL_BTN.GET_COLLECTION_AI_DESCRIPTION }
        break;
      default:
        console.log('cardAction not found for INavpanelAction', action);
        break;
    }
    return cardAction;
  }

  public activateDragZoneForceShow(): void {
    this.webNavForceShowDragZoneActivatedEvent.emit(true);
  }

  public deleteAccRequest() {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.DELETE_ACCOUNT)
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        console.log('delete acc confirmed');

       await this.cardService.disableUserRequest().then(async (resp) => {
            console.log('User request disabled successfully:', resp);
            this.dialog.closeAll();
            this.firebaseAuth.clearLocalStorageData();
            this.utilityService.showImportantSnackBar('Your account has been deleted successfully', 500);
            this.signOut();
        }).catch(async (err) => {
            if(err?.error?.status) {
              console.error('Error disabling user request:', err.error.status);
              this.utilityService.showErrorSnackBar('Error disabling user request:' + err.error.status, 1500);
            } else {
              console.error('Error disabling user request:', err);
              this.utilityService.showErrorSnackBar('Error disabling user request:' + err, 1500);
            }
        });

        setTimeout(() => {
        this.footerMode = FOOTER_MODE.LIBRARY;
        }, 500);
      }
    });
  }

  openRenderLimitDialog(requiredMinimumRenderLimitValue: number): Promise<boolean> {
    return new Promise((resolve) => {
      let confirmed = false; // Track whether the dialog was confirm
      const dialogRef = this.dialog.open(WebrenderlimitComponent, {data: { requiredMinimum: requiredMinimumRenderLimitValue }, restoreFocus: false, panelClass: 'webpopup-overlay'});
      const sub = dialogRef.componentInstance.webrenderlimitDialogueMainBtnClick.subscribe((limitNumber: number) => {
        confirmed = true; // Set the flag to true when the main button is clicked
        this.firebaseAuth.currentUser.renderLimit = limitNumber;
        this.cardService.setRenderLimit(this.firebaseAuth.currentUser.uid, this.firebaseAuth.currentUser.renderLimit).then((resp) => {
          console.log('Billing protection value updated', resp);
          resolve(true); // Confirmed by the user
        }).catch((err) => {
          this.utilityService.showImportantErrorSnackBar('Something went wrong while updating billing protection value', 0);
          console.error(err);
          resolve(false); // Error or rejection
        });
        this.dialog.closeAll();
        sub.unsubscribe();
      });
      // If the user closes the dialog without confirming
      dialogRef.afterClosed().subscribe(() => {
        if (!confirmed) {
          // Only resolve false if the confirm button wasn't clicked
          console.log('Dialog closed without confirmation');
          resolve(false);
        }
      });
    });
  }

  public openAIDescriptionDialog(aiResponse: { short_description: string; technical_description: string }): void {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.AI_DESCRIPTION, {
        '{shortDescription}': aiResponse.short_description,
        '{technicalDescription}': aiResponse.technical_description
      })
    };
    this.dialog.open(ConfirmationDialogComponent, dialogConfig);
  }

  public openAIDescriptionDialogWithApply(aiResponse: { short_description: string; technical_description: string }, collection: ICardCollection): void {
    const dialogConfig: MatDialogConfig<DialogData> = {
      data: this.utilityService.applyPopupText(POPUP_TEXT.AI_COLLECTION_DESCRIPTION, {
        '{shortDescription}': aiResponse.short_description,
        '{technicalDescription}': aiResponse.technical_description
      })
    };
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // Apply the short description to collection
        collection.collectionDescription = aiResponse.short_description;
        // Update collection locally in userDataService
        this.userDataService.updateUserCollectionInUserDrafCollections(collection);

        // Update collection on backend
        this.cardService.updateCollectionPostRequest(collection).then(() => {
          this.utilityService.showSnackBar('AI description applied to collection', 3000);
        }).catch(error => {
          this.utilityService.showErrorSnackBar(`Error updating collection: ${error?.error}`, 3000);
          console.error('Error updating collection:', error);
        });
      }
    });
  }

  private updateModelIdInUrl(cardId: string): void {
    // Do not update query parameter if URL is already in '/model/:modelId' route
    const currentPath = this.router.url.split('?')[0];
    if (currentPath.startsWith('/model/')) {
      return;
    }

    const currentQueryParams = this.getCurrentQueryParams();

    if (currentQueryParams.modelId && currentQueryParams.modelId !== cardId) {
      console.log(`Replacing modelId: ${currentQueryParams.modelId} with ${cardId}`);

      this.router.navigate([], {
        queryParams: { modelId: cardId },
        queryParamsHandling: 'merge',
        replaceUrl: true
      }).then(() => {
        console.log('modelId parameter successfully updated.');
      }).catch(err => {
        console.error('Error updating modelId parameter:', err);
      });
    } else if (!currentQueryParams.modelId) {
      console.log('modelId parameter is missing in URL. Adding it.');

      this.router.navigate([], {
        queryParams: { modelId: cardId },
        queryParamsHandling: 'merge',
        replaceUrl: true
      }).then(() => {
        console.log('modelId parameter successfully added.');
      }).catch(err => {
        console.error('Error adding modelId parameter:', err);
      });
    } else {
      console.log('modelId parameter already matches the current model.');
    }
  }

  private getCurrentQueryParams(): { [key: string]: any } {
    let queryParams: { [key: string]: any } = {};
    let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    queryParams = route.queryParams;
    return queryParams;
  }

  public async signOut() {
    this.firebaseAuth.clearLocalStorageData();
    this.firebaseAuth.logout();
    this.userDataService.cleanAllUserData();
    // The render pages (/render…) have their own landing, open to guests: signing out there goes
    // back to it (render-home.ts) — anywhere on a render-only site, where there is no library.
    if (renderOnly || /^\/render(?=[/?#]|$)/.test(this.router.url)) {
      goRenderHome(this.router);
    } else {
      this.router.navigateByUrl('/library');
    }
    // if(environment.type === 'web') {
    //   setTimeout(() => {
    //   location.reload();
    //   }, 50);
    // }
  }

  /**
   * Redirect to library page after successful authentication
   */
  public redirectToLibraryAfterAuth(): void {
    console.log('WebNavService: Redirecting to library after auth');
    // old version when i was using /get-started route
    // if (this.router.url !== '/') {
    //   this.router.navigateByUrl('/');
    // }
  }

}
